import React from 'react';
import { Helmet } from 'react-helmet-async';
import './introduction.css';
import IntroductionTabs from '../../components/common/businessInfo/IntroductionTabs';

const Introduction = () => {
  return (
    <div className="intro-page">
      <Helmet>
        <title>회사소개 - 주식회사 가까운물류</title>
      </Helmet>
      <IntroductionTabs />
    </div>
  );
};

export default Introduction;
